// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"597":"projects","893":"training"}[chunkId] + "." + {"597":"ff5fd12a","893":"7ec2be21"}[chunkId] + ".css";
};